import {
  Accordion,
  AccordionDetails,
  Divider,
  // Checkbox,
  // FormControlLabel,
  Grid,
  Typography,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { ExpandMore } from '@mui/icons-material';
import { useCallback, useEffect, useState } from 'react';
import { FormikProps } from 'formik';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import PmiTextField from 'shell/components/shared/text-field';
import { styled } from '@mui/system';
import CertiticateTypeList from '../type-certificate';
import PaymentList from 'system/components/shared/payment';
import { DatePicker } from '@mui/lab';
import {
  FiltersFormCertificate,
  SearchType,
} from 'front-office/pages/released-services/list/types';
import ServiceList from '../service-list';
import OperatorList from 'front-office/components/shared/operator-list';
import { useUserProfile } from 'shell/hooks/use-user-profile';
import VoidServiceList from '../service-void-list';

const PmiTitleDivider = styled(Typography)(({ theme }) => ({
  fontSize: '20px',
  color: theme.palette.secondary.main,
}));

interface FiltersCertificateProps {
  filterCertificateForm: FormikProps<FiltersFormCertificate>;
}

const FiltersCertificate = ({
  filterCertificateForm,
}: FiltersCertificateProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  useEffect(() => {
    if (filterCertificateForm.values.searchType === SearchType.Generic) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [filterCertificateForm.values.searchType]);

  const { userProfile } = useUserProfile();

  const handleChangeCertificateType = useCallback(
    (value) => {
      filterCertificateForm.setFieldValue('certificateType', value);
    },
    [filterCertificateForm.setFieldValue]
  );

  const handleChangePayment = useCallback(
    (value) => {
      filterCertificateForm.setFieldValue('payment', value);
    },
    [filterCertificateForm.setFieldValue]
  );

  const handleChangeService = useCallback(
    (value) => {
      filterCertificateForm.setFieldValue('service', value);
    },
    [filterCertificateForm.setFieldValue]
  );

  const handleChangeOperator = useCallback(
    (value) => {
      filterCertificateForm.setFieldValue('operator', value);
    },
    [filterCertificateForm.setFieldValue]
  );

  // const handleChangeReleaseServices = useCallback(() => {
  //   filterCertificateForm.setFieldValue('release', !filterCertificateForm.values.release);
  // }, [filterCertificateForm.setFieldValue]);

  const handleChangeServiceVoid = useCallback(
    (value) => {
      filterCertificateForm.setFieldValue('void', value);
    },
    [filterCertificateForm.setFieldValue]
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        filterCertificateForm.setValues({
          ...filterCertificateForm.values,
          fiscalCode: '',
          name: '',
          surname: '',
          withoutName: false,
          withoutSurname: false,
          searchType: SearchType.Generic,
        });
      }}
    >
      <AccordionSummary
        aria-controls="panel-certificate-content"
        id="panel-certificate-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri di ricerca</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form
          onSubmit={filterCertificateForm.handleSubmit}
          onReset={filterCertificateForm.handleReset}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12}>
              <PmiTitleDivider>Identificativo del servizio</PmiTitleDivider>
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Tipo"
                label={`Tipo ${
                  filterCertificateForm.values.dateFrom && filterCertificateForm.values.dateTo
                    ? ''
                    : '*'
                }`}
                id="type"
                name="type"
                fullWidth
                type="text"
                variant="outlined"
                value={filterCertificateForm.values.acronym || ''}
                onChange={(event) =>
                  filterCertificateForm.setFieldValue(
                    'acronym',
                    event.target.validity.valid
                      ? event.target.value
                      : filterCertificateForm.values.acronym
                  )
                }
                error={
                  filterCertificateForm.touched.acronym &&
                  Boolean(filterCertificateForm.errors.acronym)
                }
                helperText={filterCertificateForm.errors.acronym}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Anno"
                label={`Anno ${
                  filterCertificateForm.values.dateFrom && filterCertificateForm.values.dateTo
                    ? ''
                    : '*'
                }`}
                id="year"
                name="year"
                fullWidth
                type="number"
                variant="outlined"
                value={filterCertificateForm.values.year || ''}
                onChange={(event) =>
                  filterCertificateForm.setFieldValue(
                    'year',
                    event.target.validity.valid
                      ? event.target.value
                      : filterCertificateForm.values.acronym
                  )
                }
                error={
                  filterCertificateForm.touched.year && Boolean(filterCertificateForm.errors.year)
                }
                helperText={filterCertificateForm.errors.year}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Progressivo"
                label={`Progressivo ${
                  filterCertificateForm.values.dateFrom && filterCertificateForm.values.dateTo
                    ? ''
                    : '*'
                }`}
                id="progressive"
                name="progressive"
                fullWidth
                inputProps={{
                  maxLength: 6,
                  pattern: '[0-9]*',
                }}
                type="text"
                variant="outlined"
                value={filterCertificateForm.values.progressive || ''}
                onChange={(event) =>
                  filterCertificateForm.setFieldValue(
                    'progressive',
                    event.target.validity.valid
                      ? event.target.value
                      : filterCertificateForm.values.progressive
                  )
                }
                error={
                  filterCertificateForm.touched.progressive &&
                  Boolean(filterCertificateForm.errors.progressive)
                }
                helperText={filterCertificateForm.errors.progressive}
              />
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12} md={3}>
              <CertiticateTypeList
                value={filterCertificateForm.values.certificateType || ''}
                onChange={handleChangeCertificateType}
                label="Tipo servizio"
              />
            </Grid>
            {/* <Grid item xs={12} md={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    id="release"
                    name="release"
                    checked={filterCertificateForm.values.release}
                    onChange={handleChangeReleaseServices}
                    inputProps={{ 'aria-label': 'Checkbox Servizi rilasciati' }}
                  />
                }
                label="Servizi rilasciati"
              />
            </Grid> */}
            <Grid item xs={12} md={3}>
              {/* <FormControlLabel
                control={
                  <Checkbox
                    id="void"
                    name="void"
                    checked={filterCertificateForm.values.void}
                    onChange={handleChangeServiceVoid}
                    inputProps={{ 'aria-label': 'Checkbox Solo Servizi annullamenti' }}
                  />
                }
                label="Solo Servizi annullati"
              /> */}
              <VoidServiceList
                value={filterCertificateForm.values.void || ''}
                onChange={handleChangeServiceVoid}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PaymentList
                value={filterCertificateForm.values.payment || ''}
                onChange={handleChangePayment}
              />
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12} md={4}>
              {userProfile.datiLogin?.profile?.feature?.controlloDiCassa === '0' ||
              userProfile.datiLogin?.profile?.feature?.controlloDiCassa === '1' ? (
                <PmiTextField
                  id="service"
                  value={filterCertificateForm.values.serviceDesc}
                  disabled
                  label="Servizio"
                  fullWidth
                />
              ) : (
                <ServiceList
                  value={filterCertificateForm.values.service || ''}
                  onChange={handleChangeService}
                  disabled={
                    userProfile.datiLogin?.profile?.feature?.controlloDiCassa === '0' ||
                    userProfile.datiLogin?.profile?.feature?.controlloDiCassa === '1'
                  }
                />
              )}
            </Grid>
            <Grid item xs={12} md={4}>
              {userProfile.datiLogin?.profile?.feature?.controlloDiCassa === '0' ? (
                <PmiTextField
                  id="operator"
                  value={filterCertificateForm.values.operatorDesc}
                  disabled
                  fullWidth
                  label="Operatore"
                />
              ) : (
                <OperatorList
                  idService={filterCertificateForm.values.service || ''}
                  value={filterCertificateForm.values.operator || ''}
                  onChange={handleChangeOperator}
                  disabled={userProfile.datiLogin?.profile?.feature?.controlloDiCassa === '0'}
                />
              )}
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <PmiTitleDivider>Data rilascio</PmiTitleDivider>
            </Grid>
            <Grid item xs={12} md={4}>
              <DatePicker
                label={`Dal ${
                  filterCertificateForm.values.progressive &&
                  filterCertificateForm.values.acronym &&
                  filterCertificateForm.values.year
                    ? ''
                    : '*'
                }`}
                aria-label="Dal"
                value={filterCertificateForm.values.dateFrom || null}
                onChange={(date) => {
                  filterCertificateForm.setFieldValue('dateFrom', date);
                }}
                renderInput={(params) => (
                  <PmiTextField
                    {...params}
                    id="dateFrom"
                    fullWidth
                    error={
                      filterCertificateForm.touched?.dateFrom &&
                      Boolean(filterCertificateForm.errors?.dateFrom)
                    }
                    helperText={filterCertificateForm.errors?.dateFrom}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <DatePicker
                label={`Al ${
                  filterCertificateForm.values.progressive &&
                  filterCertificateForm.values.acronym &&
                  filterCertificateForm.values.year
                    ? ''
                    : '*'
                }`}
                aria-label="Al"
                value={filterCertificateForm.values.dateTo || null}
                onChange={(date) => {
                  filterCertificateForm.setFieldValue('dateTo', date);
                }}
                renderInput={(params) => (
                  <PmiTextField
                    {...params}
                    id="dateTo"
                    fullWidth
                    error={
                      filterCertificateForm.touched?.dateTo &&
                      Boolean(filterCertificateForm.errors?.dateTo)
                    }
                    helperText={filterCertificateForm.errors?.dateTo}
                  />
                )}
              />
            </Grid>
            {filterCertificateForm.values.void ? (
              <>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Grid item xs={12}>
                  <PmiTitleDivider>Data annullamento</PmiTitleDivider>
                </Grid>
                <Grid item xs={12} md={4}>
                  <DatePicker
                    label="Dal"
                    aria-label="Dal"
                    value={filterCertificateForm.values.dateFromVoid || null}
                    onChange={(date) => {
                      filterCertificateForm.setFieldValue('dateFromVoid', date);
                    }}
                    renderInput={(params) => (
                      <PmiTextField
                        {...params}
                        id="dateFromVoid"
                        fullWidth
                        error={
                          filterCertificateForm.touched?.dateFromVoid &&
                          Boolean(filterCertificateForm.errors?.dateFromVoid)
                        }
                        helperText={filterCertificateForm.errors?.dateFromVoid}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <DatePicker
                    label="Al"
                    aria-label="Al"
                    value={filterCertificateForm.values.dateToVoid || null}
                    onChange={(date) => {
                      filterCertificateForm.setFieldValue('dateToVoid', date);
                    }}
                    renderInput={(params) => (
                      <PmiTextField
                        {...params}
                        id="dateToVoid"
                        fullWidth
                        error={
                          filterCertificateForm.touched?.dateToVoid &&
                          Boolean(filterCertificateForm.errors?.dateToVoid)
                        }
                        helperText={filterCertificateForm.errors?.dateToVoid}
                      />
                    )}
                  />
                </Grid>
              </>
            ) : undefined}

            <Grid item container spacing={2} xs={12} justifyContent="flex-end" display="flex">
              <Grid item xs={12} md={2}>
                <PmiButton variant="contained" color="secondary" fullWidth type="submit">
                  Cerca
                </PmiButton>
              </Grid>
              <Grid item xs={12} md={2}>
                <PmiButton
                  variant="outlined"
                  color="cdmBrandSecondary"
                  fullWidth
                  onClick={() => {
                    filterCertificateForm.setValues({
                      ...filterCertificateForm.values,
                      acronym: '',
                      certificateType: '',
                      dateFrom: null,
                      dateFromVoid: null,
                      dateTo: null,
                      dateToVoid: null,
                      year: '',
                      release: undefined,
                      payment: '',
                      void: '',
                      searchType: SearchType.Generic,
                    });
                  }}
                >
                  Pulisci
                </PmiButton>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersCertificate.displayName = 'Filters Certificate component';

export default FiltersCertificate;
